"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const taquito_1 = require("@taquito/taquito");
const signer_1 = require("@taquito/signer");
const utils_1 = require("./utils");
const constants_1 = __importDefault(require("./constants"));
class SavingsPoolClient {
    constructor(nodeUrl, wallet, savingsPoolAddress) {
        this.savingsPoolAddress = savingsPoolAddress;
        const tezos = new taquito_1.TezosToolkit(nodeUrl);
        if (wallet instanceof signer_1.InMemorySigner) {
            tezos.setProvider({ signer: wallet });
        }
        else {
            tezos.setWalletProvider(wallet);
        }
        this.tezos = tezos;
    }
    async deposit(kUSDAmount, savingsPoolContract = undefined) {
        const depositTransaction = await this.makeDepositTransaction(kUSDAmount, savingsPoolContract);
        const sendArgs = { amount: 0, mutez: true };
        return await depositTransaction.send(sendArgs);
    }
    async makeDepositTransaction(kUSDAmount, savingsPoolContract = undefined) {
        const resolvedSavingsPoolContract = savingsPoolContract !== null && savingsPoolContract !== void 0 ? savingsPoolContract : (await this.tezos.wallet.at(this.savingsPoolAddress));
        return resolvedSavingsPoolContract.methods['deposit'](kUSDAmount);
    }
    async redeem(lpTokenAmount, savingsPoolContract = undefined) {
        const makeRedeemTransaction = await this.makeRedeemTransaction(lpTokenAmount, savingsPoolContract);
        const sendArgs = { amount: 0, mutez: true };
        return await makeRedeemTransaction.send(sendArgs);
    }
    async makeRedeemTransaction(lpTokenAmount, savingsPoolContract = undefined) {
        const resolvedSavingsPoolContract = savingsPoolContract !== null && savingsPoolContract !== void 0 ? savingsPoolContract : (await this.tezos.wallet.at(this.savingsPoolAddress));
        return resolvedSavingsPoolContract.methods['redeem'](lpTokenAmount);
    }
    async getInterestRateAPY(savingsPoolStorage = undefined) {
        const resolvedSavingsPoolStorage = savingsPoolStorage !== null && savingsPoolStorage !== void 0 ? savingsPoolStorage : (await (await this.tezos.wallet.at(this.savingsPoolAddress)).storage());
        const interestRate = resolvedSavingsPoolStorage.interestRate;
        return (0, utils_1.interestRateToApy)(interestRate);
    }
    async getPoolSize(savingsPoolStorage = undefined, time = new Date()) {
        const resolvedSavingsPoolStorage = savingsPoolStorage !== null && savingsPoolStorage !== void 0 ? savingsPoolStorage : (await (await this.tezos.wallet.at(this.savingsPoolAddress)).storage());
        const poolSize = resolvedSavingsPoolStorage.underlyingBalance;
        const lastInterestUpdateTime = resolvedSavingsPoolStorage.lastInterestCompoundTime;
        const interestRate = resolvedSavingsPoolStorage.interestRate;
        const lastUpdate = new Date(`${lastInterestUpdateTime}`);
        const deltaMs = time.getTime() - lastUpdate.getTime();
        const deltaSecs = Math.floor(deltaMs / 1000);
        const numPeriods = Math.floor(deltaSecs / constants_1.default.COMPOUND_PERIOD_SECONDS);
        return (0, utils_1.compoundingLinearApproximation)(poolSize, interestRate, numPeriods);
    }
    async getLPTokenTotal(savingsPoolStorage = undefined) {
        const resolvedSavingsPoolStorage = savingsPoolStorage !== null && savingsPoolStorage !== void 0 ? savingsPoolStorage : (await (await this.tezos.wallet.at(this.savingsPoolAddress)).storage());
        return resolvedSavingsPoolStorage.totalSupply;
    }
    async getLPTokenConversionRate(savingsPoolStorage = undefined, time = new Date()) {
        const poolSize = await this.getPoolSize(savingsPoolStorage, time);
        const totalLPTokens = await this.getLPTokenTotal(savingsPoolStorage);
        return poolSize.times(constants_1.default.PRECISION).times(constants_1.default.PRECISION).dividedBy(totalLPTokens);
    }
    async getLPTokenBalance(address, tokenContractStorage = undefined) {
        return (0, utils_1.getTokenBalance)(address, this.savingsPoolAddress, this.tezos, tokenContractStorage);
    }
    async getkUSDTokenBalance(address, savingsPoolStorage = undefined, tokenContractStorage = undefined) {
        const conversionRate = await this.getLPTokenConversionRate(savingsPoolStorage);
        const lpTokenBalance = await this.getLPTokenBalance(address, tokenContractStorage);
        return conversionRate.times(lpTokenBalance).dividedBy(constants_1.default.PRECISION);
    }
}
exports.default = SavingsPoolClient;
//# sourceMappingURL=savings-pool-client.js.map